export const PRODUCT_GO_LIVE_DATE_PREFIX = 'product_go_live_date:';
